"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var algorithms_module_1 = require("./algorithms.module");
exports.AlgorithmsModule = algorithms_module_1.AlgorithmsModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/algorithms/index.js
// module id = ../../../../../src/app/packages/menu-items/algorithms/index.js
// module chunks = main